import React from 'react';

export const PageContext = React.createContext({ action: null, company: null });

export function PageProvider({ value, children }){
  return <PageContext.Provider value={value || { action:null, company:null }}>{children}</PageContext.Provider>;
}

export function usePageMeta(){
  return React.useContext(PageContext) || { action:null, company:null };
}
